<template>
    <div>
        <div v-responsive.lg.xl class="country-code-select" ref="selectContainerDesktop">
    <div class="selected-country" @click="toggleDropdown" :class="{ 'open': isOpen }">
      <span class="flag">{{ selectedCountry.flag }}</span>
      <span class="code">{{ selectedCountry.code }}</span>
      <span class="arrow">&#9660;</span>
    </div>
    
    <!-- Regrouper tous les éléments dropdown dans un seul conteneur -->
    <div v-if="isOpen" class="dropdown-container" ref="dropdownContainer">
      <div class="dropdown">
        <div class="search-container">
          <input 
            type="text" 
            v-model="searchQuery" 
            :placeholder="searchPlaceholder" :style="{ '::placeholder': { color: 'black' } }"
            class="search-input"
            ref="searchInput"
          />
        </div>
      </div>
      
      <div class="dropdown-liste">
        <div class="options-container">
          <div 
            v-for="country in filteredCountries" 
            :key="country.iso2"
            class="option"
            @click="selectCountry(country)"
            :class="{ 'selected': country.code === selectedCountry.code }"
          >
            <span class="flag">{{ country.flag }}</span>
            <span class="code">{{ country.code }}</span>
            <span class="country-name">{{ country.country }}</span>
            <span v-if="country.code === selectedCountry.code" class="checkmark">✓</span>
          </div>
        </div>
      </div>
    </div>
        </div>

         <div v-responsive.sm.xs class="country-code-select" ref="selectContainerMobile">
    <div class="selected-country-mobile" @click="toggleDropdown" :class="{ 'open': isOpen }">
      <span class="flag">{{ selectedCountry.flag }}</span>
      <span class="code">{{ selectedCountry.code }}</span>
      <span class="arrow">&#9660;</span>
    </div>
    
    <!-- Regrouper tous les éléments dropdown dans un seul conteneur -->
    <div v-if="isOpen" class="dropdown-container" ref="dropdownContainer">
      <div class="dropdown">
        <div class="search-container">
          <input 
            type="text" 
            v-model="searchQuery" 
            :placeholder="searchPlaceholder"
            class="search-input"
            ref="searchInput"
          />
        </div>
      </div>
      
      <div class="dropdown-liste">
        <div class="options-container">
          <div 
            v-for="country in filteredCountries" 
            :key="country.iso2"
            class="option"
            @click="selectCountry(country)"
            :class="{ 'selected': country.code === selectedCountry.code }"
          >
            <span class="flag">{{ country.flag }}</span>
            <span class="code">{{ country.code }}</span>
            <span class="country-name">{{ country.country }}</span>
            <span v-if="country.code === selectedCountry.code" class="checkmark">✓</span>
          </div>
        </div>
      </div>
    </div>
        </div>
    </div>
</template>

<script>
import IntlNumber from '../common/intlNumber.json'

export default {
  name: 'CountryCodeSelect',
  props: {
    value: {
      type: String,
      default: '+221'
    },
    searchPlaceholder: {
      type: String,
      default: 'Rechercher un pays...'
    }
  },
  data() {
    return {
      isOpen: false,
      searchQuery: '',
      countries: IntlNumber
    }
  },
  computed: {
    selectedCountry() {
      return this.countries.find(country => country.code === this.value) || this.countries.find(country => country.code === '+221')
    },
    filteredCountries() {
      if (!this.searchQuery) {
        return this.countries
      }
      const query = this.searchQuery.toLowerCase()
      return this.countries.filter(country => 
        country.country.toLowerCase().includes(query) ||
        country.code.includes(query)
      )
    }
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen
      if (this.isOpen) {
        this.$nextTick(() => {
          if (this.$refs.searchInput) {
            this.$refs.searchInput.focus()
          }
        })
      } else {
        this.searchQuery = ''
      }
    },
    selectCountry(country) {
      this.$emit('input', country.code)
      this.isOpen = false
      this.searchQuery = ''
    },
    handleClickOutside(event) {
        const desktopContainer = this.$refs.selectContainerDesktop;
        const mobileContainer = this.$refs.selectContainerMobile;
        
        const clickedInsideDesktop = desktopContainer && desktopContainer.contains(event.target);
        const clickedInsideMobile = mobileContainer && mobileContainer.contains(event.target);
        
        if (!clickedInsideDesktop && !clickedInsideMobile) {
            this.isOpen = false;
            this.searchQuery = '';
        }
    },

    toggleDropdown() {
        this.isOpen = !this.isOpen;
        if (this.isOpen) {
            this.$nextTick(() => {
                // Focus sur le bon input selon le device
                const searchInput = this.$refs.searchInput || this.$refs.searchInputMobile;
                if (searchInput) {
                    searchInput.focus();
                }
            });
        } else {
            this.searchQuery = '';
        }
    }

  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside)
  }
}
</script>

<style scoped>
.country-code-select {
  position: relative;
  display: inline-block;
  width: 95px;
  margin-top: -5px;
}

.selected-country {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  background: #F99B00;
  /* border: 1px solid #ddd; */
  border-radius: 30px 0 0 30px;
  cursor: pointer;
  height: 40px;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
}

.selected-country-mobile {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  background: #F99B00;
  /* border: 1px solid #ddd; */
  border-radius: 30px 0 0 30px;
  cursor: pointer;
  height: 36px;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
}

.selected-country:hover {
  border-color: #000000;
}
.selected-country-mobile:hover {
  border-color: #000000;
}

.flag {
  margin-right: 8px;
  font-size: 16px;
}

.code {
  flex: 1;
  font-size: 14px;
  color: black;
  font-weight: 500;
  margin-right: 10px;
}

.arrow {
  font-size: 10px;
  color: black;
  transition: transform 0.3s ease;
}

.selected-country.open .arrow {
  transform: rotate(180deg);
}
.selected-country-mobile.open .arrow {
  transform: rotate(180deg);
}

.dropdown {
  position: absolute;
  top: 110%;
  left: 0;
  right: 0;
  background: #FFB032;
  border: 1px solid #F99B1B;
  border-top: none;
  border-radius: 30px 30px 8px 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 200px;
  overflow: hidden;
  width: 225px;
}
.dropdown-liste {
  position: absolute;
  top: 230%;
  left: 0;
  right: 0;
  background: #F99B1B;
  border: 1px solid #F99B1B;
  border-top: none;
  border-radius: 0px 0px 8px 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: 150px;
  overflow: hidden;
  width: 225px;
}
.search-container {
  padding: 5px;
  border-bottom: 1px solid #F99B1B;
  background: #F99B1B;
}

.search-input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #FFB032;
  border-radius: 30px;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
}

.search-input::placeholder {
  color: black;
}

.search-input:focus {
  border-color: #FFB032;
}

.options-container {
  max-height: 200px;
  overflow-y: auto;
}

.option {
  display: flex;
  align-items: center;
  padding: 2px 10px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  /* border-bottom: 1px solid #858585; */
}

.option:hover {
  background-color: #FFB032;
}

.option.selected {
  background-color: #e8f4fd;
}

.option .flag {
  margin-right: 10px;
  font-size: 16px;
}

.option .code {
  min-width: 50px;
  font-weight: 400;
  color: #333;
  margin-right: 20px;
}

.option .country-name {
  flex: 1;
  font-size: 12px;
  color: #000;
}

.checkmark {
  color: #F99B00;
  font-weight: bold;
  margin-left: 8px;
}

/* Scrollbar styling */
.options-container::-webkit-scrollbar {
  width: 6px;
}

.options-container::-webkit-scrollbar-track {
  background: #F99B1B;
}

.options-container::-webkit-scrollbar-thumb {
  background: #000;
  border-radius: 3px;
}

.options-container::-webkit-scrollbar-thumb:hover {
  background: #000;
}
</style>